import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import useBannerBackground from "hooks/useBannerBackground";

import * as Layout from "common/layout";

const { PageSection, PageContent, HeadingWrapper } = Layout;

const ViewAll = () => {
  const location = useLocation();
  // Turn url into header title
  // e.g. from my-past-classes to MY PAST CLASSES
  const currentPathname = location.pathname.split("/")[2];
  const headerTitle = currentPathname
    .split("-")
    .map((word: string) => word.toUpperCase())
    .join(" ");

  const { backgroundImage } = useBannerBackground();
  return (
    <PageContent>
      <HeadingWrapper style={backgroundImage}>{headerTitle}</HeadingWrapper>
      <PageSection>
        <Outlet />
      </PageSection>
    </PageContent>
  );
};

export default ViewAll;
